import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature template-search
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  items: [],
  locations: [],
  containers: [],
};

const clearTemplatesStore = () => initialState;

const getItemListBySearchSuccess = (state, data) => (
  P.$set('items', data, state)
);

const getLocationListBySearchSuccess = (state, data) => (
  P.$set(
    'locations',
    R.map((location) => ({
      ...location,
      [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, location)),
    }), data),
    state,
  )
);

const getContainerListBySearchSuccess = (state, data) => (
  P.$set('containers', data, state)
);


export default createReducer({
  [A.clearTemplatesStore]: clearTemplatesStore,
  [A.getItemListBySearchSuccess]: getItemListBySearchSuccess,
  [A.getLocationListBySearchSuccess]: getLocationListBySearchSuccess,
  [A.getContainerListBySearchSuccess]: getContainerListBySearchSuccess,
}, initialState);
